import { render, staticRenderFns } from "./Stay.vue?vue&type=template&id=665d33a6&"
import script from "./Stay.vue?vue&type=script&lang=js&"
export * from "./Stay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports